import { AttemptStatus } from "../../../services/gameQuizAttempts/gameQuizAttempts.types";

// Meta compartido entre la tabla y el modal de detalle. `color` sale de la
// paleta de Tag de antd (no hex hardcodeado — el design system prohíbe hex
// crudo pero permite los presets semánticos de antd).
export const STATUS_META: Record<
  AttemptStatus,
  { color: string; label: string }
> = {
  IN_PROGRESS: { color: "blue", label: "En curso" },
  COMPLETED: { color: "green", label: "Completada" },
  ABANDONED: { color: "default", label: "Abandonada" },
};
